import { render, staticRenderFns } from "./SoupItemEditable.vue?vue&type=template&id=7c01ba46&scoped=true"
import script from "./SoupItemEditable.vue?vue&type=script&lang=js"
export * from "./SoupItemEditable.vue?vue&type=script&lang=js"
import style0 from "./SoupItemEditable.vue?vue&type=style&index=0&id=7c01ba46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c01ba46",
  null
  
)

export default component.exports